import script from "./ProfileRelationshipOwnersModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileRelationshipOwnersModal.vue?vue&type=script&lang=ts&setup=true"

import "./ProfileRelationshipOwnersModal.vue?vue&type=style&index=0&id=ce617374&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce617374"]])

export default __exports__